/**
 * 直客 SaaS 认证工具类
 * 与其他两端（同行端、管理端）保持一致的JWT token机制
 */

const TOKEN_KEY = 'saas_token'
const USER_KEY = 'saas_user'

/**
 * 保存 Token
 */
export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

/**
 * 获取 Token
 */
export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

/**
 * 移除 Token
 */
export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

/**
 * 检查是否已登录
 */
export function isLoggedIn() {
  return !!getToken()
}

/**
 * 保存用户信息
 */
export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

/**
 * 获取用户信息
 */
export function getUser() {
  const userStr = localStorage.getItem(USER_KEY)
  return userStr ? JSON.parse(userStr) : null
}

/**
 * 移除用户信息
 */
export function removeUser() {
  localStorage.removeItem(USER_KEY)
}

/**
 * 清除所有认证信息（退出登录）
 */
export function clearAuth() {
  removeToken()
  removeUser()
}

/**
 * 保存登录状态（Token + 用户信息）
 */
export function saveAuth(token, user) {
  setToken(token)
  setUser(user)
}

/**
 * 获取认证请求头
 */
export function getAuthHeader() {
  const token = getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

/**
 * 检查登录状态（简单检查token是否存在）
 */
export function checkAuth() {
  return { loggedIn: isLoggedIn() }
}

/**
 * 退出登录
 */
export function logout() {
  clearAuth()
  return { success: true }
}
